import request from "@/utils/request";

export async function list() {
  const response = await request.get("/categories");
  return response.data.data;
}